// src/Login.js
import React, { useState } from 'react';
import axios from 'axios';
import Header from './Header';
import Welcome from './Welcome';
import { Link } from 'react-router-dom';
import { BsFillPersonFill, BsFillLockFill } from 'react-icons/bs';
import { MdEmail } from "react-icons/md";
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'; 
import NewHeader from './NewHeader';
import Market from './Market';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import Footer from './Footer';


const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [loggedIn, setLoggedIn] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate(); // Initialize useNavigate




    
    const showNotice = (message) => {
        setMessage(message);
        
        // Set a timeout to clear the notice after 3 seconds
        setTimeout(() => {
          setMessage('');
        }, 5000); // 3000 milliseconds = 3 seconds
      };
    
    
      const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
      };



    const handleLogin = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const response = await axios.post('https://mybackend-new.onrender.com/login', {
                username,
                password
            });

            if (response.status === 200) {
                localStorage.setItem('token', response.data.token);
                setLoggedIn(true); // Update loggedIn state to true upon successful login
            } else {
                setMessage('Login failed. You entered wrong credentials');
            }
        } catch (error) {
            showNotice('Login failed. You entered wrong credentials.');
        }
        finally {
            setIsSubmitting(false); // Reset the loading state
          }
    };

    if (loggedIn) {
        navigate('/Market'); // Redirect to login if no token  
    }

    return (
        <div className="relative min-h-screen">
          

            <div className="relative z-10">
                <NewHeader/>
                <div className="pt-8 flex items-center justify-center min-h-[80vh]">
                    <div className="max-w-md w-full px-6 py-10 m-3 flex flex-col items-center bg-white rounded-3xl">
                        <div className="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center mb-4">
                            <BsFillPersonFill className="text-4xl text-gray-600" />
                        </div>
                        <h2 className="text-2xl font-bold text-gray-800 mb-2 text-center">Welcome Back</h2>
                        <h5 className="mb-6 text-center text-gray-500 text-sm">Sign in to start your session</h5>
                        <form onSubmit={handleLogin} className="w-full">
                            <div className="mb-6 relative">
                                <input
                                    type="text"
                                    className="text-base w-full px-4 py-4 border-b border-gray-200 focus:border-gray-400 focus:outline-none transition bg-transparent"
                                    placeholder="Enter your email"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    required
                                />
                                <MdEmail className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={22} />
                            </div>
                            <div className="mb-6 relative">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    className="text-base w-full px-4 py-4 border-b border-gray-700 focus:border-gray-400 focus:outline-none transition bg-transparent"
                                    placeholder="Enter your password"
                                    minLength={8}
                                    maxLength={30}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={togglePasswordVisibility}
                                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400"
                                    tabIndex={-1}
                                >
                                    {showPassword ? <AiFillEyeInvisible size={22} /> : <AiFillEye size={22} />}
                                </button>
                            </div>
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className={`w-full bg-orange-500 text-white py-3 px-4 rounded-xl font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 hover:bg-gray-600 transition-all duration-300 ${
                                    isSubmitting ? 'bg-blue-300 cursor-not-allowed' : ''
                                }`}
                            >
                                {isSubmitting ? (
                                    <span className="flex justify-center items-center">
                                        <svg
                                            className="animate-spin h-5 w-5 mr-2 text-white"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                        >
                                            <circle cx="12" cy="12" r="10" strokeWidth="4" />
                                            <path
                                                fill="none"
                                                stroke="currentColor"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="4"
                                                d="M4 12a8 8 0 0116 0"
                                            />
                                        </svg>
                                        Signing in...
                                    </span>
                                ) : (
                                    'Login'
                                )}
                            </button>
                        </form>
                        {message && <p className="text-red-500 text-center mt-4">{message}</p>}
                        <div className="mt-6 text-center w-full flex flex-col gap-2">
                            <p className="text-sm">
                                Forgot password? <Link to="/Reset" className="text-blue-500 hover:underline">Reset</Link>
                            </p>
                            <div className="flex items-center justify-center">
                                <span className="h-px w-16 bg-blue-200"></span>
                                <span className="mx-2 text-blue-400 text-xs font-semibold">OR</span>
                                <span className="h-px w-16 bg-blue-200"></span>
                            </div>
                            <p className="text-sm">
                                Don't have an account? <Link to="/SignUp" className="text-blue-500 hover:underline">Sign up</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default Login;
